<script>
	import { onMount } from 'svelte';
	import { goto } from '@roxi/routify';
	import SvelteTable from "svelte-table";
	import { getGETAPILink, getData, postFormData, capitalizeFirstLetter, postJsonData } from "../helpers.js";
	import { guardDate, clampDate, MIN_DATE, MAX_DATE } from '../dateGuard.js';
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import DateTypeInput from "../components/DateTypeInput.svelte";
	
	let today = new Date()
	const oneYearFromNow = new Date(today);
	oneYearFromNow.setFullYear(today.getFullYear() + 1);
	const oneYearFromNowString = oneYearFromNow.toISOString().split('T')[0];
	let todayString = `${today.getFullYear().toString().padStart(4, '0')}-${(today.getMonth()+1).toString().padStart(2, '0')}-${(today.getDate()).toString().padStart(2, '0')}`
	let threeYearsAgo = new Date(today.getFullYear() - 3, today.getMonth(), today.getDate());
	let threeYearsAgoString = `${threeYearsAgo.getFullYear().toString().padStart(4, '0')}-${(threeYearsAgo.getMonth()+1).toString().padStart(2, '0')}-${(threeYearsAgo.getDate()).toString().padStart(2, '0')}`
	// Calculate date ranges for active projects filter (70 years to cover long infrastructure projects)
	const seventyYearsAgo = new Date(today.getFullYear() - 70, today.getMonth(), today.getDate());
	const seventyYearsAgoString = `${seventyYearsAgo.getFullYear().toString().padStart(4, '0')}-${(seventyYearsAgo.getMonth()+1).toString().padStart(2, '0')}-${(seventyYearsAgo.getDate()).toString().padStart(2, '0')}`;
	const seventyYearsFromNow = new Date(today.getFullYear() + 70, today.getMonth(), today.getDate());
	const seventyYearsFromNowString = `${seventyYearsFromNow.getFullYear().toString().padStart(4, '0')}-${(seventyYearsFromNow.getMonth()+1).toString().padStart(2, '0')}-${(seventyYearsFromNow.getDate()).toString().padStart(2, '0')}`;


	let [dirProjectIdError, awardingBodyError, projectNameError, contractorError, contractorPwcrError, contractorLicCslbError, subcontractorError, subcontractorPwcrError, subcontractorLicCslbError,
		advertisedBidStartDateError, advertisedBidEndDateError, projectAwardStartDateError, projectAwardEndDateError, estimatedStartStartDateError, estimatedStartEndDateError,
		estimatedCompletionStartDateError, estimatedCompletionEndDateError, classificationError, contractAmountError, physicalLocatorTypeError, addressLineOneError, addressLineTwoError, cityError, usStateError, zipcodeError, mailStopError,
		locationDescriptionError, countyError, sortByError, whichDbError] = ['','','','','','','','','','','','','','','','','','','','','','','','','','','','','','',''];
	let [dirProjectId, awardingBody, projectName, contractor, contractorPwcr, contractorLicCslb, subcontractor, subcontractorPwcr, subcontractorLicCslb,
		advertisedBidStartDate, advertisedBidEndDate, projectAwardStartDate, projectAwardEndDate, estimatedStartStartDate, estimatedStartEndDate,
		estimatedCompletionStartDate, estimatedCompletionEndDate, classification, contractAmount, addressLineOne, addressLineTwo, city, usState, zipcode, mailStop,
		locationDescription, county, sortBy] = ['','','','','','','','','','','','','','','','','','','','','','','','','','','','',''];

	let partySearchMode = 'name'; // 'name' | 'pwcr' | 'cslb'

	projectAwardStartDate = threeYearsAgoString;
	projectAwardEndDate = oneYearFromNowString;

	let easterEggModal = ''; // '' | 'past' | 'future' | 'eternity'
	let easterEggAcknowledged = false;
	let easterEggSource = 'desktop';

	let eggMessage = '';
	let [bcStart, bcEnd] = ['', ''];
	const bcCompose = (v, flag) => (flag === '-' && v ? '-' + v : v);
	const guardTimers = {};
	function guardField(e, key, bcFlag) {
		clearTimeout(guardTimers[key]);
		const target = e.target;
		guardTimers[key] = setTimeout(() => {
			const r = guardDate(key, target.value, bcFlag === '-');
			target.value = r.value;
			if (r.message) eggMessage = r.message;
			if (key === 'pwc-start') searchStartDate = r.value;
			else searchEndDate = r.value;
		}, 1200);
	}
	function clampField(value, key) {
		clearTimeout(guardTimers[key]);
		guardTimers[key] = setTimeout(() => {
			const v = clampDate(value);
			if (key === 'pwc-start-mobile') searchStartDate = v;
			else searchEndDate = v;
		}, 1200);
	}
	function sliverInput(e) {
		const v = e.target.value === '-' ? '-' : '';
		e.target.value = v;
		return v;
	}
	
	let whichDb = true;
	let physicalLocatorType = false;
	let otherError = '';
	let searchForm;
	let searchFormMobile;
	let userEditedDates = false;
	let [searchStartDateError, searchEndDateError] = ['', ''];

	let downloadFeedback = '';
	let downloadFeedbackTimer;
	function flashDownloadFeedback() {
		downloadFeedback = 'Download started — also available in History';
		clearTimeout(downloadFeedbackTimer);
		downloadFeedbackTimer = setTimeout(() => downloadFeedback = '', 4000);
	}

	// Replace all individual date vars with:
	let searchStartDate = threeYearsAgoString;
	let searchEndDate = oneYearFromNowString;
	let dateMode = 'active'; // 'upcoming_bids' | 'awarded' | 'active' | 'all' 

	const threeYearsFromNow = new Date(today.getFullYear() + 3, today.getMonth(), today.getDate());
	const threeYearsFromNowString = `${threeYearsFromNow.getFullYear().toString().padStart(4, '0')}-${(threeYearsFromNow.getMonth()+1).toString().padStart(2, '0')}-${(threeYearsFromNow.getDate()).toString().padStart(2, '0')}`;

	// Reactive: radio button pre-fills dates
	$: if (dateMode === 'upcoming_bids') {
		searchStartDate = todayString;
		searchEndDate = oneYearFromNowString;
	} else if (dateMode === 'awarded') {
		searchStartDate = '2013-12-18'; //MPWSP Desal Plant PID 20260635480
		searchEndDate = todayString;
	} else if (dateMode === 'active') {
		searchStartDate = '';
		searchEndDate = '';
	} else if (dateMode === 'all_time') {
		searchStartDate = threeYearsAgoString;
		searchEndDate = threeYearsFromNowString;
		userEditedDates = false;
	}

	$: dateFields = (() => {
		let fields = {
			advertised_bid_start_date: '',
			advertised_bid_end_date: '',
			project_award_start_date: '',
			project_award_end_date: '',
			estimated_start_start_date: '',
			estimated_start_end_date: '',
			estimated_completion_start_date: '',
			estimated_completion_end_date: '',
		};
		if (dateMode === 'upcoming_bids') {
			fields.advertised_bid_start_date = bcCompose(searchStartDate, bcStart);
			fields.advertised_bid_end_date = bcCompose(searchEndDate, bcEnd);
		} else if (dateMode === 'awarded') {
			fields.estimated_start_start_date = todayString;
		} else if (dateMode === 'active') {
			fields.estimated_completion_start_date = todayString;
			if (userEditedDates) {
				if (searchStartDate) fields.project_award_start_date = bcCompose(searchStartDate, bcStart);
				if (searchEndDate) fields.project_award_end_date = bcCompose(searchEndDate, bcEnd);
        	}
		}
		return fields;
	})();

	/*
	let activeProjectsFilter = false;
	// Reactive: Update date fields when checkbox is toggled
	$: if (activeProjectsFilter) {
		estimatedStartStartDate = seventyYearsAgoString;    // Started anytime since 1955
		estimatedStartEndDate = todayString;                // But by today
		estimatedCompletionStartDate = todayString;         // Ends today or later
		estimatedCompletionEndDate = seventyYearsFromNowString;  // Up to 70 years out
		projectAwardStartDate = '';
		projectAwardEndDate = '';
	} else {
		projectAwardStartDate = threeYearsAgoString;
		projectAwardEndDate = oneYearFromNowString;
		estimatedStartStartDate = '';
		estimatedStartEndDate = '';
		estimatedCompletionStartDate = '';
		estimatedCompletionEndDate = '';
	}
	*/
	
	let previewLoading = false;
	let previewError = "";
	let previewMetrics = {
		awardingBodies: {},
		contractors: {},
		projects: {},
		totalAmount: 0,
	};

	function showActiveProjects() {
		// Clear all fields first
		dirProjectId = '';
		awardingBody = '';
		projectName = '';
		contractor = '';
		// ... clear other fields as needed
		
		// Set date ranges for active projects
		estimatedStartEndDate = todayString; // Started on or before today
		estimatedCompletionStartDate = todayString; // Ends on or after today
		
		// Optionally trigger search automatically
		handleSearch();
	}


	function buildPreviewRows(data) {
		const projectMap = {};
		let count = 0;

		for (const [dirId, project] of Object.entries(data)) {
			if (count >= 100) break;

			const amountRaw = project.amount_float || project.amount;
			const amount = amountRaw ? Number(String(amountRaw).replace(/,/g, '')) : NaN;

			let awardDate = "N/A";
			if (project.award_date) {
				const d = new Date(project.award_date * 1000);
				awardDate = `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')}`;
			}

			projectMap[dirId] = {
				id: project.project_id || dirId,
				projectName: project.name || "N/A",
				awardingBody: project.awarding_body_name || "N/A",
				awardDate,
				contractNumber: project.contract_number || "",
				amount,
				amountFormatted: Number.isFinite(amount) ? `$${amount.toLocaleString('en-US', { maximumFractionDigits: 0 })}` : "N/A",
				city: project.city || "N/A",
				county: project.county || "N/A",
				contractors: (project.contractors || []).map(c => ({
					name: c.name || "N/A",
					legalName: c.legal_name || "N/A",
					cslb: c.cslb || "",
					homeCity: c.city || ""
				})),
				$expanded: false
			};
			count++;
		}

		return Object.values(projectMap);
	}

	function computePreviewMetrics(data) {
		const awardingBodies = {};
		const contractors = {};
		const projects = {};
		let totalAmount = 0;

		for (const [dirId, project] of Object.entries(data)) {
			const body = (project.awarding_body_name || "Unknown").trim();
			awardingBodies[body] = (awardingBodies[body] || 0) + 1;

			const projName = (project.name || "Unknown").trim();
			projects[projName] = (projects[projName] || 0) + 1;

			for (const contractor of (project.contractors || [])) {
				const name = (contractor.name || "Unknown").trim();
				contractors[name] = (contractors[name] || 0) + 1;
			}

			const amountRaw = project.amount_float || project.amount;
			if (amountRaw) {
				const val = Number(String(amountRaw).replace(/,/g, ''));
				if (Number.isFinite(val)) totalAmount += val;
			}
		}

		return { awardingBodies, contractors, projects, totalAmount };
	}

	let previewRows = [];
	async function loadPreviewFromZip(searchId) {
		if (!searchId || cancelledIds.has(searchId)) return;
		previewLoading = true;
		previewError = "";

		try {
			const url = getGETAPILink("pwc100-search/preview", { search_id: searchId });
			const response = await fetch(url, { credentials: "include" });
			if (!response.ok) throw new Error(`Preview failed (${response.status})`);

			const jsonData = await response.json();
			const data = jsonData.data;

			previewRows = buildPreviewRows(data);
			previewMetrics = computePreviewMetrics(data);
			previewData = { total_count: Object.keys(data).length };
			previewError = "";
			searchState = "preview-data";
		} catch (err) {
			previewError = err.message || "Failed to load preview.";
		} finally {
			previewLoading = false;
		}
	}

	let expandedArr = [];
	function handleRowClick(event) {
		const row = event.detail.row;
		if (!row.$expanded) {
			expandedArr = [...expandedArr, row.id];
		} else {
			expandedArr = expandedArr.filter(id => id !== row.id);
		}
	}

	let pwc100ReportFeature = false;
	let csvReport = false;

	getData('user/paywall-features').then(response => response.json()).then(ret_json => {
		if (ret_json.status === 'success') {
			pwc100ReportFeature = ret_json.features.includes('PWC100_REPORT');
			csvReport = pwc100ReportFeature;
		}
	});

	
	let searchState = 'form'

	// …existing imports/state…

	let previewData = null;
	let previewFilteredRows = [];
	let previewSortBy = "projectName";
	let previewSortOrder = 1;

	const PREVIEW_COLUMNS = {
		projectID: {
			key: "projectID",
			title: "DIR Proj. ID",
			value: row => row.id ?? "N/A",
			sortable: true,
			headerClass: "bg-blue-100"
		},
		contractNumber: {
			key: "contractNumber",
			title: "Contract",
			value: row => row.contractNumber || "N/A",
			sortable: true,
			headerClass: "bg-blue-100"
		},
		projectName: {
			key: "projectName",
			title: "Project",
			value: row => row.projectName ?? "N/A",
			sortable: true,
			headerClass: "bg-blue-100"
		},
		awardingBody: {
			key: "awardingBody",
			title: "Awarding Body",
			value: row => row.awardingBody ?? "N/A",
			sortable: true,
			headerClass: "bg-blue-100"
		},
		awardDate: {
			key: "awardDate",
			title: "Awarded",
			value: row => row.awardDate ?? "N/A",
			sortable: true,
			class: "whitespace-nowrap",
			headerClass: "bg-blue-100"
		},
		contractors: {
			key: "contractors",
			title: "Contractors",
			value: row => {
				if (row.contractors.length === 0) {
					return "N/A";
				} else if (row.contractors.length === 1) {
					// Show just the contractor name
					return row.contractors[0].name || "N/A";
				} else {
					// Show first contractor + count of additional ones
					const firstName = row.contractors[0].name || "Unknown";
					const additionalCount = row.contractors.length - 1;
					return `${firstName} (+${additionalCount})`;
				}
			},
			sortable: true,
			headerClass: "bg-blue-100"
		},
		amount: {
			key: "amount",
			title: "Amount",
			value: row => row.amount || 0,
			renderValue: row => row.amountFormatted,
			sortable: true,
			className: "text-right"
		},
		city: {
			key: "city",
			title: "City",
			value: row => row.city ?? "N/A",
			sortable: true,
			headerClass: "bg-blue-100"
		},
		contractorName: {
			key: "contractorName",
			title: "Contractor Name",
			value: row => row.contractorName ?? "N/A",
			sortable: true,
		},
		contractorLegalName: {
			key: "contractorLegalName",
			title: "Legal Name",
			value: row => row.contractorLegalName ?? "N/A",
			sortable: true,
		},
	};

	let selectedPreviewCols = [
		"contractNumber",
		"awardDate",
		"projectName",
		"projectID",
		"awardingBody",
		"contractors",
		"city",
		"amount"
	];
	$: previewColumns = selectedPreviewCols.map(key => PREVIEW_COLUMNS[key]);
	$: mobileSortedRows = [...previewRows].sort((a, b) => {
		const dateA = a.awardDate || '';
		const dateB = b.awardDate || '';
		return dateB.localeCompare(dateA);
	});
	
	async function useMyLocation() {
		if (!navigator.geolocation) {
			otherError = 'Location services not available in your browser';
			return;
		}
		
		// Show loading state
		otherError = 'Detecting location...';
		
		const options = {
			enableHighAccuracy: true,
			timeout: 10000,  // 10 second timeout
			maximumAge: 0     // Don't use cached position
		};
		
		navigator.geolocation.getCurrentPosition(
			async (position) => {
				const lat = position.coords.latitude;
				const lon = position.coords.longitude;
				
				try {
					const response = await fetch(
						`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=14`
					);
					const data = await response.json();

					console.log('Nominatim response:', data);  

					// Try zip first (most specific), then city, then county
					const detectedZip = data.address?.postcode || '';
					const detectedCity = data.address?.city || data.address?.town || data.address?.village || '';
					const detectedCounty = data.address?.county || '';
					
					console.log('Detected zip:', detectedZip, 'city:', detectedCity, 'county:', detectedCounty);

					if (detectedCounty) {
						county = detectedCounty.replace(/ County$/i, '');
					}
					if (detectedZip) {
						zipcode = detectedZip;
						otherError = '';
					} else if (detectedCity) {
						city = detectedCity;
						otherError = '';
					} else if (detectedCounty) {
						otherError = '';
					} else {
						otherError = 'Could not determine location';
					}
				} catch (err) {
					console.error('Geocoding error:', err);
					otherError = 'Failed to determine location. Please try again.';
				}
			},
			(error) => {
				console.error('Geolocation error:', error);
				// Provide more specific error messages based on error code
				switch(error.code) {
					case error.PERMISSION_DENIED:
						otherError = 'Location permission denied. Please enable location in your browser settings.';
						break;
					case error.POSITION_UNAVAILABLE:
						otherError = 'Location information unavailable.';
						break;
					case error.TIMEOUT:
						otherError = 'Location request timed out. Please try again.';
						break;
					default:
						otherError = 'An unknown error occurred while detecting location.';
				}
				// Uncheck the box since it failed
				useMyLocationFilter = false;
			},
			options  // Add the options here
		);
	}

	// Reactive: Clear location fields when "Use My Location" is unchecked
	let useMyLocationFilter = false;
	$: if (!useMyLocationFilter) {
		// Only clear when unchecked
		zipcode = '';
		city = '';
		county = '';
	}

	let searchId = '';
	const cancelledIds = new Set();
	let searchSubmit = false;
	function handleSearch() {
		easterEggSource = 'desktop';
		if (dateMode === 'all_time' && !easterEggAcknowledged) {
			if (!searchStartDate && !searchEndDate) {
				easterEggModal = 'eternity';
				return;
			} else if (!searchStartDate) {
				easterEggModal = 'past';
				return;
			} else if (!searchEndDate) {
				easterEggModal = 'future';
				return;
			}
		}
		easterEggAcknowledged = false;

		let res = postFormData('pwc100-search/submit', searchForm);
		searchSubmit = true;
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				otherError = '';
				searchId = ret_json.search_id;
				cancelledIds.delete(searchId)
				//setTimeout(updateSearchStatus(searchId), 750); // Prevent Invalid Search ID
				setTimeout(() => updateSearchStatus(searchId), 750)
				searchState = 'searching'
			} else if (ret_json.status === 'error') {
				if (ret_json.error === 'Account not valid.') {
					otherError = 'Billing not entered, please update payment information';
				} else {
					otherError = ret_json.error || 'An unknown error has occured. Please try again.';
				}
			} else {
				otherError = 'An unknown error has occured. Please try again.';
			}
			searchSubmit = false;
		}).catch(() => {
			otherError = 'An unknown error has occured. Please try again.';
			searchSubmit = false;
		});
	}

	function handleSearchMobile() {
		easterEggSource = 'mobile';
		if (dateMode === 'all_time' && !easterEggAcknowledged) {
			if (!searchStartDate && !searchEndDate) {
				easterEggModal = 'eternity';
				return;
			} else if (!searchStartDate) {
				easterEggModal = 'past';
				return;
			} else if (!searchEndDate) {
				easterEggModal = 'future';
				return;
			}
		}
		easterEggAcknowledged = false;

		let res = postFormData('pwc100-search/submit', searchFormMobile);
		searchSubmit = true;
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				otherError = '';
				searchId = ret_json.search_id;
				cancelledIds.delete(searchId)
				setTimeout(() => updateSearchStatus(searchId), 750)
				searchState = 'searching'
			} else if (ret_json.status === 'error') {
				if (ret_json.error === 'Account not valid.') {
					otherError = 'Billing not entered, please update payment information';
				} else {
					otherError = ret_json.error || 'An unknown error has occured. Please try again.';
				}
			} else {
				otherError = 'An unknown error has occured. Please try again.';
			}
			searchSubmit = false;
		}).catch(() => {
			otherError = 'An unknown error has occured. Please try again.';
			searchSubmit = false;
		});
	}

	let searchStatus = 'downloading';
	let statusTimeoutID;
	function updateSearchStatus(searchId) {
		if (!searchId || cancelledIds.has(searchId)) {
			return;
		}
		let res = getData('pwc100-search/status', {search_id: searchId});
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				searchStatus = ret_json.search_status;
				if (ret_json.search_status === 'downloading' || ret_json.search_status === 'searching') {
					//statusTimeoutID = setTimeout(updateSearchStatus, 2000, searchId); // 2 sec for delay
					statusTimeoutID = setTimeout(() => updateSearchStatus(searchId), 2000);
				} else if (ret_json.search_status === "finished") {
					if (searchState !== "preview-data") {
						loadPreviewFromZip(searchId);
					}
				} else {
					searchStatus = ''; // unk error
					otherError = 'An unknown error has occured. Please try again.';
				}
			} else {
				searchStatus = "error";
				otherError = ret_json.error;
			}
		});
	}


	
	function newSearch() {
		searchState = 'form'; // default
		previewData = null;
     	previewRows = [];
		previewError = "";
  		previewLoading = false;
		previewMetrics = { awardingBodies: {}, contractors: {}, projects: {}, totalAmount: 0 };
		searchStatus = 'downloading'; // default
		easterEggModal = '';
		easterEggAcknowledged = false;
		userEditedDates = false
		// Clear checkboxes
		//activeProjectsFilter = false;
		useMyLocationFilter = false;
		if (searchId) {
			cancelledIds.add(searchId);
			}
		searchId = '';
		searchSubmit = false;
		otherError = '';
		clearTimeout(statusTimeoutID);
		[dirProjectIdError, awardingBodyError, projectNameError, contractorError, contractorPwcrError, contractorLicCslbError, subcontractorError, subcontractorPwcrError, subcontractorLicCslbError,
		advertisedBidStartDateError, advertisedBidEndDateError, projectAwardStartDateError, projectAwardEndDateError, estimatedStartStartDateError, estimatedStartEndDateError,
		estimatedCompletionStartDateError, estimatedCompletionEndDateError, classificationError, contractAmountError, physicalLocatorTypeError, addressLineOneError, addressLineTwoError, cityError, usStateError, zipcodeError, mailStopError,
		locationDescriptionError, countyError, sortByError, whichDbError] = ['','','','','','','','','','','','','','','','','','','','','','','','','','','','','','',''];
		[dirProjectId, awardingBody, projectName, contractor, contractorPwcr, contractorLicCslb, subcontractor, subcontractorPwcr, subcontractorLicCslb,
		advertisedBidStartDate, advertisedBidEndDate, projectAwardStartDate, projectAwardEndDate, estimatedStartStartDate, estimatedStartEndDate,
		estimatedCompletionStartDate, estimatedCompletionEndDate, classification, contractAmount, addressLineOne, addressLineTwo, city, usState, zipcode, mailStop,
		locationDescription, county, sortBy] = ['','','','','','','','','','','','','','','','','','','','','','','','','','','','','',''];
		whichDb = true;
		physicalLocatorType = false;

	}

	// --- Collapsible search side panel (desktop preview-data view) ---
	const PANEL_OPEN_KEY = 'pwc100Search.panelOpen';
	const PANEL_WIDTH_KEY = 'pwc100Search.panelWidthPct';

	// Safe localStorage wrappers: browsers with site data blocked throw on
	// any localStorage access, so fall back to defaults silently.
	function storageGet(key, fallback) {
		try {
			const v = localStorage.getItem(key);
			return v === null ? fallback : JSON.parse(v);
		} catch {
			return fallback;
		}
	}
	function storageSet(key, value) {
		try {
			localStorage.setItem(key, JSON.stringify(value));
		} catch {
			// Storage blocked: feature still works, just won't persist.
		}
	}

	let panelOpen = storageGet(PANEL_OPEN_KEY, false) === true;
	let panelWidthPct = Number(storageGet(PANEL_WIDTH_KEY, 33));
	if (!Number.isFinite(panelWidthPct) || panelWidthPct < 20 || panelWidthPct > 60) {
		panelWidthPct = 33;
	}

	$: splitView = searchState === 'preview-data' && panelOpen;

	// Split-view form layout: stack field pairs into one column
	$: rowCls = splitView ? 'flex flex-col space-y-3' : 'flex space-x-4';
	$: colCls = splitView ? 'input w-full' : 'input w-1/2';

	function togglePanel() {
		panelOpen = !panelOpen;
		storageSet(PANEL_OPEN_KEY, panelOpen);
	}

	// Draggable divider between side panel and results
	let splitContainer;
	let dragging = false;
	function dividerDown(e) {
		dragging = true;
		e.target.setPointerCapture(e.pointerId);
	}
	function dividerMove(e) {
		if (!dragging || !splitContainer) return;
		const rect = splitContainer.getBoundingClientRect();
		const pct = ((e.clientX - rect.left) / rect.width) * 100;
		panelWidthPct = Math.min(60, Math.max(20, pct));
	}
	function dividerUp() {
		if (!dragging) return;
		dragging = false;
		storageSet(PANEL_WIDTH_KEY, Math.round(panelWidthPct * 10) / 10);
	}

	let dataCurrentDate = '...'; // placeholder until fetch resolves
	onMount(() => {
		getData('pwc100-search/data-date').then(r => r.json()).then(ret_json => {
			if (ret_json.status === 'success' && ret_json.data_date) {
				dataCurrentDate = ret_json.data_date;
			}
		}).catch(() => {});
	});

	
</script>

<main class=background>
	<Navbar/>

	<div class="bg-amber-50 border-l-4 border-amber-400 p-4 mx-4 mt-4 text-sm text-amber-900">
		<p>
			<strong>Contractor-linked results may be incomplete.</strong> 
		</p>
		<p class="mt-2">
			California DIR's contractor-to-project link table is missing identity data on approximately 19,900 records across 15,500 projects (of 637K+ total). Of those, ~5,100 projects have no identified contractor at all and display "Contractors: N/A." The remaining ~10,300 have named prime contractors and are not visibly affected -- meaning they silently fail. This pattern begins in the dataset mid-2024, coinciding with DIR's restructuring of its Public Works website services — see DIR's <a href="https://www.dir.ca.gov/Public-Works/DIRs-Modernized-Public-Works-Website-Services.html" class="text-blue-700 underline" target="_blank" rel="noopener">modernized Public Works website services notice</a>. Affected projects are predominantly (a) recently-filed, low-value projects from smaller agencies; or (b) larger agencies' filings that will have named primes but carry unfilled sub-contractor placeholders.
		</p>
		<p class="mt-2">
			If a contractor or PWCR search comes up short, try the DIR Project ID instead. We are backfilling eCPR records for the affected projects — eCPR data retains contractor associations independently of DIR's link table. We expect the ~5,100 affected projects to be fully reconciled within the coming months. We have also recovered over 1,300 missing associations from our historical records and are restoring more as we find them.
		</p>
	</div>

	{#if easterEggModal}
		<div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
			<div class="bg-white rounded-lg p-8 max-w-lg mx-4 shadow-xl">
				{#if easterEggModal === 'past'}
					<p class="text-xl text-blue-900 mb-4">Do you really want to go back to the dawn of time and the Roman Colosseum?</p>
					<p class="text-gray-600 mb-6">California DIR electronic records begin June 24, 2014. Your search will go back to the earliest available data.</p>
				{:else if easterEggModal === 'future'}
					<p class="text-xl text-blue-900 mb-4">Planning ahead for orbital solar farms and a Dyson swarm?</p>
					<p class="text-gray-600 mb-6">Your search will include all future-dated projects in the system.</p>
				{:else if easterEggModal === 'eternity'}
					<p class="text-xl text-blue-900 italic mb-4">"High up in the North in the land called Svithjod, there stands a rock. It is a hundred miles high and a hundred miles wide. Once every thousand years a little bird comes to this rock to sharpen its beak. When the rock has thus been worn away, then a single day of eternity will have gone by."</p>
					<p class="text-gray-600 mb-6">Your search spans all time — from the earliest DIR record to the death of heat itself, and with it the database.</p>
				{/if}
				<div class="flex justify-end space-x-4">
					<button on:click={() => { easterEggModal = ''; }}
						class="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold">
						Cancel
					</button>
					<button on:click={() => { easterEggModal = ''; easterEggAcknowledged = true; easterEggSource === 'mobile' ? handleSearchMobile() : handleSearch(); }}
						class="px-4 py-2 rounded-md bg-blue-500 hover:bg-blue-700 text-white font-semibold">
						Proceed
					</button>
				</div>
			</div>
		</div>
	{/if}

	{#if eggMessage}
		<div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
			<div class="bg-white rounded-lg p-8 max-w-lg mx-4 shadow-xl">
				<p class="text-xl text-blue-900 mb-6">{eggMessage}</p>
				<div class="flex justify-end">
					<button type="button" on:click={() => eggMessage = ''}
						class="px-4 py-2 rounded-md bg-blue-500 hover:bg-blue-700 text-white font-semibold">
						Understood
					</button>
				</div>
			</div>
		</div>
	{/if}

	<div class="flex flex-col space-y-3 mt-6 items-center lg:flex-row lg:justify-center">
		<div class="mx-2 !mb-4 px-10 py-6 {searchState === 'preview-data' ? 'max-w-full lg:mx-6' : 'max-w-6xl'} w-full flex-1 card">

			<!-- Use hidden to preserve form state instead of discarding -->
			<div class="hidden lg:block"> <!-- Cheap way out, especially since layout change on desktop-->
				<div class="{splitView ? 'flex items-start' : ''}" bind:this={splitContainer}>
				<div class="{searchState === 'form' ? '' : (splitView ? 'min-w-0 overflow-y-auto max-h-[75vh] pr-3' : 'hidden')}"
					style="{splitView ? `flex: 0 0 ${panelWidthPct}%;` : ''}">
					<p class="{splitView ? 'text-lg' : 'text-2xl'} font-semibold text-blue-900 mb-4">Search PWC100 Data</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<form method="POST" class="h-full relative" bind:this={searchForm} on:submit|preventDefault={handleSearch}>
						<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
						<div class="flex flex-col space-y-3 {splitView ? 'text-base' : 'text-xl'}">
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<input id="dir-project-id" name="proj_id" bind:value={dirProjectId} placeholder="DIR Project ID" class="peer z-20 placeholder:text-transparent {dirProjectIdError === '' ? '' : 'border-red-600'}"/>
										<label for="dir-project-id" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">DIR Project ID</label>
									</div>
									<p class="error-text {dirProjectIdError === '' ? 'hidden' : ''}">{dirProjectIdError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<input id="awarding-body" name="awarding_body" bind:value={awardingBody} placeholder="Awarding Body" class="peer z-20 placeholder:text-transparent {awardingBodyError === '' ? '' : 'border-red-600'}"/>
										<label for="awarding-body" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Awarding Body</label>
									</div>
									<p class="error-text {awardingBodyError === '' ? 'hidden' : ''}">{awardingBodyError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-full'>
									<div class="relative">
										<input id="project-name" name="proj_name" bind:value={projectName} placeholder="Project Name" class="peer z-20 placeholder:text-transparent {projectNameError === '' ? '' : 'border-red-600'}"/>
										<label for="project-name" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Project Name</label>
									</div>
									<p class='error-text {projectNameError === '' ? 'hidden' : ''}'>{projectNameError}</p>
								</div>
							</div>
							<div></div>
							<div class="flex space-x-4">
								<div class='input w-full'>
									<div class="relative">
										<input id="contractor" name="contractor" bind:value={contractor} placeholder="Contractor Name" class="peer z-20 placeholder:text-transparent {contractorError === '' ? '' : 'border-red-600'}"/>
										<label for="contractor" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor Name</label>
									</div>
									<p class='error-text {contractorError === '' ? 'hidden' : ''}'>{contractorError}</p>
								</div>
							</div>
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<input id="contractor-pwcr-num" name="contractor_pwcr_num" bind:value={contractorPwcr} placeholder="Contractor PWCR" class="peer z-20 placeholder:text-transparent {contractorPwcrError === '' ? '' : 'border-red-600'}"/>
										<label for="contractor-pwcr-num" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor PWCR</label>
									</div>
									<p class='error-text {contractorPwcrError === '' ? 'hidden' : ''}'>{contractorPwcrError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<input id="contractor-license-cslb-num" name="contractor_license_cslb_num" bind:value={contractorLicCslb} placeholder="Contractor Lic/CSLB" class="peer z-20 placeholder:text-transparent {contractorLicCslbError === '' ? '' : 'border-red-600'}"/>
										<label for="contractor-license-cslb-num" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor Lic/CSLB</label>
									</div>
									<p class='error-text {contractorLicCslbError === '' ? 'hidden' : ''}'>{contractorLicCslbError}</p>
								</div>
							</div>
							<div></div>
							<div class="flex space-x-4">
								<div class='input w-full'>
									<div class="relative">
										<input id="subcontractor" name="subcontractor" bind:value={subcontractor} placeholder="Subcontractor Name" class="peer z-20 placeholder:text-transparent {subcontractorError === '' ? '' : 'border-red-600'}"/>
										<label for="subcontractor" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Subcontractor Name</label>
									</div>
									<p class='error-text {subcontractorError === '' ? 'hidden' : ''}'>{subcontractorError}</p>
								</div>
							</div>
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<input id="subcontractor-pwcr-num" name="subcontractor_pwcr_num" bind:value={subcontractorPwcr} placeholder="Subcontractor PWCR" class="peer z-20 placeholder:text-transparent {subcontractorPwcrError === '' ? '' : 'border-red-600'}"/>
										<label for="subcontractor-pwcr-num" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Subcontractor PWCR</label>
									</div>
									<p class='error-text {subcontractorPwcrError === '' ? 'hidden' : ''}'>{subcontractorPwcrError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<input id="subcontractor-lic-cslb" name="subcontractor_license_cslb_num" bind:value={subcontractorLicCslb} placeholder="Subcontractor Lic/CSLB" class="peer z-20 placeholder:text-transparent {subcontractorLicCslbError === '' ? '' : 'border-red-600'}"/>
										<label for="subcontractor-lic-cslb" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Subcontractor Lic/CSLB</label>
									</div>
									<p class='error-text {subcontractorLicCslbError === '' ? 'hidden' : ''}'>{subcontractorLicCslbError}</p>
								</div>
							</div>
							
							<div class="flex flex-col space-y-2 mb-4">
								<!--
								<div class="flex items-center space-x-2">
									<input id="active-projects-filter" bind:checked={activeProjectsFilter} type="checkbox" class="w-5"/>
									<label for="active-projects-filter">Show Active Projects Only</label>
								</div>
								-->
								<div class="flex items-center space-x-2">
									<input id="use-location-filter" type="checkbox" bind:checked={useMyLocationFilter} on:change={(e) => {
										if (e.target.checked) {
											useMyLocation();
										}
									}} class="w-5"/>
									<label for="use-location-filter">Use My Location for Nearby Projects</label>
								</div>
							</div>

							<fieldset class="flex flex-col space-y-3">
								<div class="flex flex-wrap gap-4">
									<label class="flex items-center space-x-1 text-gray-400 cursor-not-allowed" title="Note: Bid dates are self-reported after award. This filter may return incomplete results as most records don't have forward-looking bid dates.">
										<input type="radio" name="date_mode" value="upcoming_bids" bind:group={dateMode} disabled/>
										<span>Upcoming Bids</span>
									</label>
									<label class="flex items-center space-x-1" title="Approximately half of award dates appear to be placeholder values mirroring start date rather than actual award dates.">
										<input type="radio" name="date_mode" value="awarded" bind:group={dateMode}/>
										<span>Awarded (pre-NTP)</span>
									</label>
									<label class="flex items-center space-x-1">
										<input type="radio" name="date_mode" value="active" bind:group={dateMode}/>
										<span>Active Projects</span>
									</label>
									<label class="flex items-center space-x-1">
										<input type="radio" name="date_mode" value="all_time" bind:group={dateMode}/>
										<span>All Time</span>
									</label>
								</div>
								<div class={rowCls}>
									<div class={colCls}>
										<label class="flex space-x-2">
											<p class="my-auto">Start: </p>
											<input class="bc-sliver" type="text" maxlength="1" value={bcStart} aria-hidden="true" tabindex="-1"
												on:input={(e) => bcStart = sliverInput(e)}/>
											<input name="search_start_date" value={searchStartDate} type='date' class="input-field"
												disabled={dateMode === 'active' || dateMode === 'awarded'}
												class:opacity-40={dateMode === 'active' || dateMode === 'awarded'}
												on:input={() => userEditedDates = true}
												on:change={(e) => guardField(e, 'pwc-start', bcStart)}
											/>
										</label>
									</div>
									<div class={colCls}>
										<label class="flex space-x-2">
											<p class="my-auto">End: </p>
											<input class="bc-sliver" type="text" maxlength="1" value={bcEnd} aria-hidden="true" tabindex="-1"
												on:input={(e) => bcEnd = sliverInput(e)}/>
											<input name="search_end_date" value={searchEndDate} type='date' class="input-field"
												disabled={dateMode === 'active' || dateMode === 'awarded'}
												class:opacity-40={dateMode === 'active' || dateMode === 'awarded'}
												on:input={() => userEditedDates = true}
												on:change={(e) => guardField(e, 'pwc-end', bcEnd)}
											/>
										</label>
									</div>
								</div>
							</fieldset>
							
							<!-- Hidden fields for backend compatibility -->
							<input type="hidden" name="advertised_bid_start_date" value={dateFields.advertised_bid_start_date}/>
							<input type="hidden" name="advertised_bid_end_date" value={dateFields.advertised_bid_end_date}/>
							<input type="hidden" name="project_award_start_date" value={dateFields.project_award_start_date}/>
							<input type="hidden" name="project_award_end_date" value={dateFields.project_award_end_date}/>
							<input type="hidden" name="estimated_start_start_date" value={dateFields.estimated_start_start_date}/>
							<input type="hidden" name="estimated_start_end_date" value={dateFields.estimated_start_end_date}/>
							<input type="hidden" name="estimated_completion_start_date" value={dateFields.estimated_completion_start_date}/>
							<input type="hidden" name="estimated_completion_end_date" value={dateFields.estimated_completion_end_date}/>

							<div class="input inline-block w-Full">
								<div class="tooltip-div">
									<legend class="my-auto pb-2 w-Full">Premium Options: </legend>
									<p class='tooltip'>Please contact us for premium license, support@paloaltodatagroup.com</p>
								</div>
								<div class="tooltip-div">
									<div class="flex my-auto text-lg space-x-4">
										<input id="csv-report" name="csv_report" bind:checked={csvReport} disabled type="checkbox" class="w-5 ml-4"/>
										{#if pwc100ReportFeature}
											<label for="csv-report">CSV Report</label>
										{:else}
											<a href="/integrations" class="text-gray-500 underline hover:text-blue-600" title="Subscribe on the Integrations page to activate">CSV Report</a>
										{/if}
									</div>
									<p class='tooltip'>{pwc100ReportFeature ? 'Downloads the full search results as a spreadsheet csv report.' : 'Requires the Core Downloader Subscription — click to open the Integrations page.'}</p>
								</div>
							</div>

							<input type="submit" value="Submit" disabled={searchSubmit}
								class="{splitView ? 'w-full' : 'w-4/12'} pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
							
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<select id="classification" name="classification" bind:value={classification} class="input-field mt-4 {classificationError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a Classification</option><option value="ASBESTOS">ASBESTOS</option><option value="BOILERMAKER">BOILERMAKER</option><option value="BRICKLAYERS">BRICKLAYERS</option><option value="CARPENTERS">CARPENTERS</option><option value="CARPET/LINOLEUM">CARPET/LINOLEUM</option><option value="CEMENT MASONS">CEMENT MASONS</option><option value="DRYWALL FINISHER">DRYWALL FINISHER</option><option value="DRYWALL/LATHERS">DRYWALL/LATHERS</option><option value="ELECTRICIANS">ELECTRICIANS</option><option value="ELEVATOR MECHANIC">ELEVATOR MECHANIC</option><option value="GLAZIERS">GLAZIERS</option><option value="IRON WORKERS">IRON WORKERS</option><option value="LABORERS">LABORERS</option><option value="MILLWRIGHTS">MILLWRIGHTS</option><option value="OPERATING ENG">OPERATING ENG</option><option value="PAINTERS">PAINTERS</option><option value="PILE DRIVERS">PILE DRIVERS</option><option value="PIPE TRADES">PIPE TRADES</option><option value="PLASTERERS">PLASTERERS</option><option value="ROOFERS">ROOFERS</option><option value="SHEET METAL">SHEET METAL</option><option value="SOUND/COMM">SOUND/COMM</option><option value="SURVEYORS">SURVEYORS</option><option value="TEAMSTER">TEAMSTER</option><option value="TILE WORKERS">TILE WORKERS</option>
										</select>
										<label for="classification" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Classification</label>
									</div>
									<p class='error-text {classificationError === '' ? 'hidden' : ''}'>{classificationError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<select id="contract-amount" name="contract_amount" bind:value={contractAmount} class="input-field mt-4 {contractAmountError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a Contract Amount</option><option value="$0.00 - $5,000">$0.00 - $5,000</option><option value="$5,000 - $50,000">$5,000 - $50,000</option><option value="$50,000 - $500,000">$50,000 - $500,000</option><option value="$500,000 - $5,000,000">$500,000 - $5,000,000</option><option value="$5,000,000 - $50,000,000">$5,000,000 - $50,000,000</option><option value="Greater than $50,000,000">Greater than $50,000,000</option>
										</select>
										<label for="contract-amount" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Contract Amount</label>
									</div>
									<p class='error-text {contractAmountError === '' ? 'hidden' : ''}'>{contractAmountError}</p>
								</div>
							</div>

							<!--
							<fieldset class="flex space-x-4">
								<legend class="my-auto pb-2 w-1/4">Project Award: </legend>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">Start: </p> 
										<input id="project-award-start-date" name="project_award_start_date" bind:value={projectAwardStartDate} placeholder="Project Award - Start Date" type='date' class="input-field {projectAwardStartDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {projectAwardStartDateError === '' ? 'hidden' : ''}'>{projectAwardStartDateError}</p>
								</div>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">End: </p> 
										<input id="project-award-end-date" name="project_award_end_date" bind:value={projectAwardEndDate} placeholder="Project Award - End Date" type='date' class="input-field {projectAwardEndDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {projectAwardEndDateError === '' ? 'hidden' : ''}'>{projectAwardEndDateError}</p>
								</div>
							</fieldset>
							<fieldset class="flex space-x-4">
								<legend class="my-auto pb-2 w-1/4">Advertised Bid: </legend>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">Start: </p>
										<input id="advertised-bid-start-date" name="advertised_bid_start_date" bind:value={advertisedBidStartDate} placeholder="Advertised Bid - Start Date" type='date' class="input-field {advertisedBidStartDateError === '' ? '' : 'border-red-600'}"/>
									</label>									
									<p class='error-text {advertisedBidStartDateError === '' ? 'hidden' : ''}'>{advertisedBidStartDateError}</p>
								</div>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">End: </p> 
										<input id="advertised-bid-end-date" name="advertised_bid_end_date" bind:value={advertisedBidEndDate} placeholder="Advertised Bid - End Date" type='date' class="input-field {advertisedBidEndDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {advertisedBidEndDateError === '' ? 'hidden' : ''}'>{advertisedBidEndDateError}</p>
								</div>
							</fieldset>
							<fieldset class="flex space-x-4">
								<legend class="my-auto pb-2 w-1/4">Estimated Start: </legend>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">Start: </p> 
										<input id="estimated-start-start-date" name="estimated_start_start_date" bind:value={estimatedStartStartDate} placeholder="Estimated Start - Start Date" type='date' class="input-field {estimatedStartStartDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {estimatedStartStartDateError === '' ? 'hidden' : ''}'>{estimatedStartStartDateError}</p>
								</div>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">End: </p> 
										<input id="estimated-start-end-date" name="estimated_start_end_date" bind:value={estimatedStartEndDate} placeholder="Estimated Start - End Date" type='date' class="input-field {estimatedStartEndDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {estimatedStartEndDateError === '' ? 'hidden' : ''}'>{estimatedStartEndDateError}</p>
								</div>
							</fieldset>
							<fieldset class="flex space-x-4">
								<legend class="my-auto pb-2 w-1/4">Estimated Completion: </legend>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">Start: </p> 
										<input id="estimated-completion-start-date" name="estimated_completion_start_date" bind:value={estimatedCompletionStartDate} placeholder="Estimated Completion - Start Date" type='date' class="input-field {estimatedCompletionStartDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {estimatedCompletionStartDateError === '' ? 'hidden' : ''}'>{estimatedCompletionStartDateError}</p>
								</div>
								<div class='input w-1/2'>
									<label class="flex space-x-2">
										<p class="my-auto">End: </p> 
										<input id="estimated-completion-end-date" name="estimated_completion_end_date" bind:value={estimatedCompletionEndDate} placeholder="Estimated Completion - End Date" type='date' class="input-field {estimatedCompletionEndDateError === '' ? '' : 'border-red-600'}"/>
									</label>
									<p class='error-text {estimatedCompletionEndDateError === '' ? 'hidden' : ''}'>{estimatedCompletionEndDateError}</p>
								</div>
							</fieldset>
							<div></div>
							-->
							
							<div></div>
							<input type="hidden" name="physical_locator_type" value="Address"/>
							<!--
							<div class="flex space-x-4">
								<label class="relative inline-flex items-center cursor-pointer w-1/2">
									<input type="checkbox" name="physical_locator_switch" bind:checked={physicalLocatorType} class="sr-only peer">
									<div class="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
									{#if physicalLocatorType}
										<input class="hidden" name="physical_locator_type" value="Location">
										<span class="ml-3 text-md font-medium text-gray-900">Physical Locator: Description</span>
									{:else}
										<input class="hidden" name="physical_locator_type" value="Address">
										<span class="ml-3 text-md font-medium text-gray-900">Physical Locator: Address</span>
									{/if}
									<p class='error-text {physicalLocatorTypeError === '' ? 'hidden' : ''}'>{physicalLocatorTypeError}</p>
								</label>
							</div>

							{#if physicalLocatorType}
							<div class="flex space-x-4">
								<div class='input w-full'>
									<label for="location-description">Location Description: </label>
									<textarea type="text" id="location-description" name="location_description" bind:value={locationDescription} placeholder="Location Description" class="w-full input-field {locationDescriptionError === '' ? '' : 'border-red-600'}"></textarea>
									<p class='error-text {locationDescriptionError === '' ? 'hidden' : ''}'>{locationDescriptionError}</p>
								</div>
							</div>
							{:else}
							-->
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<input id="address-line-one" name="address_line_one" bind:value={addressLineOne} placeholder="Address Line One" class="peer z-20 placeholder:text-transparent {addressLineOneError === '' ? '' : 'border-red-600'}"/>
										<label for="address-line-one" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Address Line One</label>
									</div>
									<p class='error-text {addressLineOneError === '' ? 'hidden' : ''}'>{addressLineOneError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<input id="address-line-two" name="address_line_two" bind:value={addressLineTwo} placeholder="Address Line Two" class="peer z-20 placeholder:text-transparent {addressLineTwoError === '' ? '' : 'border-red-600'}"/>
										<label for="address-line-two" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Address Line Two</label>
									</div>
									<p class='error-text {addressLineTwoError === '' ? 'hidden' : ''}'>{addressLineTwoError}</p>
								</div>
							</div>
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<input id="city" name="city" bind:value={city} placeholder="City" class="peer z-20 placeholder:text-transparent {cityError === '' ? '' : 'border-red-600'}"/>
										<label for="city" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">City</label>
									</div>
									<p class='error-text {cityError === '' ? 'hidden' : ''}'>{cityError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<select id="us-state" name="us_state" bind:value={usState} class="input-field mt-4 {usStateError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a State</option><option value="AL">AL</option><option value="AK">AK</option><option value="AZ">AZ</option><option value="AR">AR</option><option value="CA">CA</option><option value="CO">CO</option><option value="CT">CT</option><option value="DE">DE</option><option value="DC">DC</option><option value="FL">FL</option><option value="GA">GA</option><option value="HI">HI</option><option value="ID">ID</option><option value="IL">IL</option><option value="IN">IN</option><option value="IA">IA</option><option value="KS">KS</option><option value="KY">KY</option><option value="LA">LA</option><option value="ME">ME</option><option value="MD">MD</option><option value="MA">MA</option><option value="MI">MI</option><option value="MN">MN</option><option value="MS">MS</option><option value="MO">MO</option><option value="MT">MT</option><option value="NE">NE</option><option value="NV">NV</option><option value="NH">NH</option><option value="NJ">NJ</option><option value="NM">NM</option><option value="NY">NY</option><option value="NC">NC</option><option value="ND">ND</option><option value="OH">OH</option><option value="OK">OK</option><option value="OR">OR</option><option value="PA">PA</option><option value="RI">RI</option><option value="SC">SC</option><option value="SD">SD</option><option value="TN">TN</option><option value="TX">TX</option><option value="UT">UT</option><option value="VT">VT</option><option value="VA">VA</option><option value="WA">WA</option><option value="WV">WV</option><option value="WI">WI</option><option value="WY">WY</option>
										</select>
										<label for="us-state" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">State</label>
									</div>
									<p class='error-text {usStateError === '' ? 'hidden' : ''}'>{usStateError}</p>
								</div>
								<div class={colCls}>
									<div class="relative">
										<input id="zipcode" type="number" min="0" step="1" name="zipcode" bind:value={zipcode} placeholder="Zipcode" class="peer z-20 placeholder:text-transparent {zipcodeError === '' ? '' : 'border-red-600'}"/>
										<label for="zipcode" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Zipcode</label>
									</div>
									<p class='error-text {zipcodeError === '' ? 'hidden' : ''}'>{zipcodeError}</p>
								</div>
								<!--
								<div class='input w-1/2'>
									<div class="relative">
										<input id="mail-stop" type="number" min="0" step="1" name="mail_stop" bind:value={mailStop} placeholder="Mail Stop" class="peer z-20 placeholder:text-transparent {mailStopError === '' ? '' : 'border-red-600'}"/>
										<label for="mail-stop" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Mail Stop</label>
									</div>
									<p class='error-text {mailStopError === '' ? 'hidden' : ''}'>{mailStopError}</p>
								</div>
								-->
							</div>
							<!--{/if}-->
							<div class={rowCls}>
								<div class={colCls}>
									<div class="relative">
										<select id="county" name="county" bind:value={county} class="input-field mt-4 {countyError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a County</option><option value="Out of state:">Out of state:</option><option value="Alameda">Alameda</option><option value="Alpine">Alpine</option><option value="Amador">Amador</option><option value="Butte">Butte</option><option value="Calaveras">Calaveras</option><option value="Colusa">Colusa</option><option value="Contra Costa">Contra Costa</option><option value="Del Norte">Del Norte</option><option value="El Dorado">El Dorado</option><option value="Fresno">Fresno</option><option value="Glenn">Glenn</option><option value="Humboldt">Humboldt</option><option value="Imperial">Imperial</option><option value="Inyo">Inyo</option><option value="Kern">Kern</option><option value="Kings">Kings</option><option value="Lake">Lake</option><option value="Lassen">Lassen</option><option value="Los Angeles">Los Angeles</option><option value="Madera">Madera</option><option value="Marin">Marin</option><option value="Mariposa">Mariposa</option><option value="Mendocino">Mendocino</option><option value="Merced">Merced</option><option value="Modoc">Modoc</option><option value="Mono">Mono</option><option value="Monterey">Monterey</option><option value="Napa">Napa</option><option value="Nevada">Nevada</option><option value="Orange">Orange</option><option value="Placer">Placer</option><option value="Plumas">Plumas</option><option value="Riverside">Riverside</option><option value="Sacramento">Sacramento</option><option value="San Benito">San Benito</option><option value="San Bernardino">San Bernardino</option><option value="San Diego">San Diego</option><option value="San Francisco">San Francisco</option><option value="San Joaquin">San Joaquin</option><option value="San Luis Obispo">San Luis Obispo</option><option value="San Mateo">San Mateo</option><option value="Santa Barbara">Santa Barbara</option><option value="Santa Clara">Santa Clara</option><option value="Santa Cruz">Santa Cruz</option><option value="Shasta">Shasta</option><option value="Sierra">Sierra</option><option value="Siskiyou">Siskiyou</option><option value="Solano">Solano</option><option value="Sonoma">Sonoma</option><option value="Stanislaus">Stanislaus</option><option value="Sutter">Sutter</option><option value="Tehama">Tehama</option><option value="Trinity">Trinity</option><option value="Tulare">Tulare</option><option value="Tuolumne">Tuolumne</option><option value="Ventura">Ventura</option><option value="Yolo">Yolo</option><option value="Yuba">Yuba</option>
										</select>
										<label for="county" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">County</label>
									</div>
									<p class='error-text {countyError === '' ? 'hidden' : ''}'>{countyError}</p>
								</div>
								<!-- Sort by removed — appears broken, can restore if needed
								<div class={colCls}>
									<div class="relative">
										<select id="sort-by" name="sort_by" bind:value={sortBy} class="input-field mt-4 {sortByError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a Sort Filter</option><option value="Awarding Body">Awarding Body</option><option value="Project Name">Project Name</option><option value="Contractor Name">Contractor Name</option><option value="County">County</option><option value="Classification">Classification</option><option value="Contract Amount">Contract Amount</option>
										</select>
										<label for="sort-by" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Sort Filter</label>
									</div>
									<p class='error-text {sortByError === '' ? 'hidden' : ''}'>{sortByError}</p>
								</div>
								-->
							</div>
							<!--
							<div></div>
							<div class="flex space-x-4">
								<label class="relative inline-flex items-center cursor-pointer">
									<input id="which-db" type="checkbox" name="which_db_switch" bind:checked={whichDb} class="sr-only peer">
									<div class="w-14 h-7 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
									{#if whichDb}
										<input class="hidden" name="which_db" value="New">
										<label for="which-db" class="ml-3 text-md font-medium text-gray-900">Search Type: New (Data current up to: {dataCurrentDate})</label>
										{:else}
										<input class="hidden" name="which_db" value="Old">
										<label for="which-db" class="ml-3 text-md font-medium text-gray-900">Search Type: Old (Data current up to: 2024-05-16)</label>
									{/if}
									<p class='error-text {whichDbError === '' ? 'hidden' : ''}'>{whichDbError}</p>
								</label>
							</div>
							-->
							<input type="hidden" name="which_db" value="New"/>
							<p class="text-sm text-gray-500 mt-2">Data current up to: {dataCurrentDate}</p>
							
						</div>
					</form>
				</div>

				{#if splitView}
					<div
						role="separator"
						aria-orientation="vertical"
						class="w-1.5 shrink-0 self-stretch cursor-col-resize rounded bg-gray-300 hover:bg-blue-400 touch-none select-none"
						on:pointerdown|preventDefault={dividerDown}
						on:pointermove={dividerMove}
						on:pointerup={dividerUp}
						on:pointercancel={dividerUp}
					></div>
				{/if}

				<!-- PWC100 Preview Results -->
				{#if searchState === "preview-data" && previewData}
					<div class="preview-results {panelOpen ? 'min-w-0 flex-1 pl-3' : ''}">
						<div class="flex items-center justify-between mb-4">
							<p class="text-2xl font-semibold text-blue-900">Search Results Preview</p>
							<button type="button" on:click={togglePanel}
								class="px-3 py-1 text-base rounded-md border border-blue-500 text-blue-600 hover:bg-blue-50 font-semibold"
								title="{panelOpen ? 'Collapse search panel' : 'Edit search alongside results'}">
								{panelOpen ? '⟩ Hide Search' : '⟨ Search'}
							</button>
						</div>

						<p class="text-lg mb-3">
							{previewData.total_count?.toLocaleString() ?? 0}
							{previewData.total_count === 1 ? 'project found' : 'projects found'}
						</p>

						{#if previewData.total_count > 100}
							<p class="text-orange-600 mb-4">
								Showing first 100 results in preview. Download full results for complete data.
							</p>
						{/if}


						{#if previewLoading}
							<p class="text-center text-blue-600 mt-6">Loading preview…</p>
						{:else if previewError}
							<p class="text-center text-red-600 mt-6">{previewError}</p>
						{:else}
							<div class="grid md:grid-cols-4 gap-4 mb-6">
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Total Value</p>
									<p class="text-sm text-gray-700">
										${previewMetrics.totalAmount.toLocaleString('en-US', { maximumFractionDigits: 0 })}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Awarding Bodies</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.awardingBodies)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Contractors</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.contractors)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Projects</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.projects)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
							</div>

							<div class="overflow-auto max-h-[65vh]">
								<SvelteTable
									bind:filteredRows={previewFilteredRows}
									columns={previewColumns}
									rows={previewRows}
									sortBy={previewSortBy}
									sortOrder={previewSortOrder}
									expandRowKey="id"
									bind:expanded={expandedArr}
									on:clickRow={handleRowClick}
									classNameRow="hover:bg-gray-50 odd:bg-white even:bg-gray-200 cursor-pointer"
									classNameRowExpanded="bg-blue-100"
									classNameExpandedContent="bg-blue-50"
									classNameThead={['table-primary sticky top-0 bg-white']}
									classNameTbody={['w-full overflow-scroll']}
									classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
								>
									<svelte:fragment slot="expanded" let:row>
										<div class="p-4">
											<p class="font-semibold mb-2">Contractors on this project:</p>
											<li>
												{#each row.contractors as contractor}
													<li>
														{contractor.name}
														{#if contractor.cslb}
															<span class="text-gray-500 text-sm ml-1">#{contractor.cslb}</span>
														{/if}
														{#if contractor.homeCity}
															<span class="text-gray-500 text-sm ml-1">{contractor.homeCity}</span>
														{/if}
														{#if contractor.legalName !== contractor.name}
															<span class="text-gray-600 text-sm">({contractor.legalName})</span>
														{/if}
													</li>
												{/each}
											</li>
											<p class="text-gray-500 text-sm mt-2 italic">
												Contractors not registered on the PWC-100 may still have filed eCPRs on this project &mdash; a CPR Search by DIR Project ID will extract them.
											</p>
										</div>
									</svelte:fragment>
								</SvelteTable>
							</div>

							<div class="mt-6 space-x-5 flex justify-center">
								{#if pwc100ReportFeature}
									<a href="{getGETAPILink('pwc100-search/download', {'search_id': searchId})}" download="{searchId}.csv" target="_self" on:click={flashDownloadFeedback}>
										<button class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
										Download Full Results
										</button>
									</a>
								{:else}
									<button disabled class="px-6 py-2 text-xl rounded-md bg-gray-400 cursor-not-allowed text-gray-200 font-semibold"
										title="PWC100 Report feature required for download">
									Download Full Results
									</button>
								{/if}
								{#if !splitView}
									<button type="button" on:click={newSearch} class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
										New Search
									</button>
								{/if}
							</div>
							{#if downloadFeedback}
								<p class="text-green-700 text-lg text-center mt-2">{downloadFeedback}</p>
							{/if}

						{/if}
					</div>
				{/if}
				</div> <!-- end split-view wrapper -->

				{#if searchState === 'searching'}
					<div class="text-center py-12">
						<!--<p class="text-xl text-blue-600">Searching PWC100 Database...</p>-->
						<p class="text-gray-500 mt-2">This may take a moment</p>
					</div>
				{/if}

				<div class="{searchState === 'searching' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">{capitalizeFirstLetter(searchStatus)}</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<div class="mt-5 space-y-3">
						<p class="text-xl font-semibold">Search ID: {searchId}</p>
						{#if searchStatus === 'downloading'}
							<p class="text-xl font-semibold">Status: {capitalizeFirstLetter(searchStatus)}</p>
						{:else if searchStatus === 'finished'}
							<div class="mt-6 space-x-5 flex justify-center">
								{#if pwc100ReportFeature}
									<a href="{getGETAPILink('pwc100-search/download', {'search_id': searchId})}" download="{searchId}.csv" target="_self" on:click={flashDownloadFeedback}>
										<button class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
										Download Full Results
										</button>
									</a>
								{:else}
									<button disabled class="px-6 py-2 text-xl rounded-md bg-gray-400 cursor-not-allowed text-gray-200 font-semibold"
										title="PWC100 Report feature required for download">
									Download Full Results
									</button>
								{/if}
								<button type="button" on:click={newSearch} class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
									New Search
								</button>
							</div>
							{#if downloadFeedback}
								<p class="text-green-700 text-lg text-center mt-2">{downloadFeedback}</p>
							{/if}
						{:else if searchStatus === 'error' || (previewData?.total_count ?? 0) === 0}
							<div class="space-x-5 mt-5">
								<button type="button" on:click={newSearch}
									class="w-2/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								New Search</button>
							</div>
						{/if}
					</div>
				</div>
			</div>


			<div class="block lg:hidden"> <!-- Mobile Display -->
				<div class="{searchState === 'form' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900 mb-0">Search PWC100 Data</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<form method="POST" class="h-full relative" bind:this={searchFormMobile} on:submit|preventDefault={handleSearchMobile}>
						<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
						<div class="flex flex-col space-y-3 text-xl">
							<div class='input w-full'>
								<div class="relative">
									<input id="dir-project-id-mobile" name="proj_id" bind:value={dirProjectId} placeholder="DIR Project ID" class="peer z-20 placeholder:text-transparent {dirProjectIdError === '' ? '' : 'border-red-600'}"/>
									<label for="dir-project-id-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">DIR Project ID</label>
								</div>
								<p class="error-text {dirProjectIdError === '' ? 'hidden' : ''}">{dirProjectIdError}</p>
							</div>
							<div class='input w-full'>
								<div class="relative">
									<input id="awarding-body-mobile" name="awarding_body" bind:value={awardingBody} placeholder="Awarding Body" class="peer z-20 placeholder:text-transparent {awardingBodyError === '' ? '' : 'border-red-600'}"/>
									<label for="awarding-body-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Awarding Body</label>
								</div>
								<p class="error-text {awardingBodyError === '' ? 'hidden' : ''}">{awardingBodyError}</p>
							</div>
							<div class='input w-full'>
								<div class="relative">
									<input id="project-name-mobile" name="proj_name" bind:value={projectName} placeholder="Project Name" class="peer z-20 placeholder:text-transparent {projectNameError === '' ? '' : 'border-red-600'}"/>
									<label for="project-name-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Project Name</label>
								</div>
								<p class='error-text {projectNameError === '' ? 'hidden' : ''}'>{projectNameError}</p>
							</div>
							<div></div>

							<div class="segmented-control segmented-row">
								<button type="button" class="{partySearchMode === 'name' ? 'active' : ''}" on:click={() => partySearchMode = 'name'}>Name</button>
								<button type="button" class="{partySearchMode === 'pwcr' ? 'active' : ''}" on:click={() => partySearchMode = 'pwcr'}>PWCR</button>
								<button type="button" class="{partySearchMode === 'cslb' ? 'active' : ''}" on:click={() => partySearchMode = 'cslb'}>Lic/CSLB</button>
							</div>
							<div class='input w-full'>
								<div class="relative">
									<input id="contractor-mobile" name={partySearchMode === 'name' ? 'contractor' : partySearchMode === 'pwcr' ? 'contractor_pwcr_num' : 'contractor_license_cslb_num'} bind:value={contractor} placeholder="Contractor {partySearchMode === 'name' ? 'Name' : partySearchMode === 'pwcr' ? 'PWCR' : 'Lic/CSLB'}" class="peer z-20 placeholder:text-transparent {contractorError === '' ? '' : 'border-red-600'}"/>
									<label for="contractor-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor {partySearchMode === 'name' ? 'Name' : partySearchMode === 'pwcr' ? 'PWCR' : 'Lic/CSLB'}</label>
								</div>
								<p class='error-text {contractorError === '' ? 'hidden' : ''}'>{contractorError}</p>
							</div>
							<div class='input w-full'>
								<div class="relative">
									<input id="subcontractor-mobile" name={partySearchMode === 'name' ? 'subcontractor' : partySearchMode === 'pwcr' ? 'subcontractor_pwcr_num' : 'subcontractor_license_cslb_num'} bind:value={subcontractor} placeholder="Subcontractor {partySearchMode === 'name' ? 'Name' : partySearchMode === 'pwcr' ? 'PWCR' : 'Lic/CSLB'}" class="peer z-20 placeholder:text-transparent {subcontractorError === '' ? '' : 'border-red-600'}"/>
									<label for="subcontractor-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Subcontractor {partySearchMode === 'name' ? 'Name' : partySearchMode === 'pwcr' ? 'PWCR' : 'Lic/CSLB'}</label>
								</div>
								<p class='error-text {subcontractorError === '' ? 'hidden' : ''}'>{subcontractorError}</p>
							</div>

							<div class="flex flex-col space-y-2 mb-4">

								<div class="flex items-center space-x-2">
									<input id="use-location-filter" type="checkbox" bind:checked={useMyLocationFilter} on:change={(e) => {
										if (e.target.checked) {
											useMyLocation();
										}
									}} class="w-5"/>
									<label for="use-location-filter">Projects near me</label>
								</div>
							</div>
							<div class="tooltip-div">
								<legend class="my-auto pb-2 w-Full">Premium Options:</legend>
								<p class='tooltip'>For premium license: support@paloaltodatagroup.com</p>
							</div>
							<div class="flex my-auto text-lg space-x-4 mb-4">
								<input id="csv-report-mobile" name="csv_report" bind:checked={csvReport} disabled type="checkbox" class="w-5"/>
								{#if pwc100ReportFeature}
									<label for="csv-report-mobile">CSV Report</label>
								{:else}
									<a href="/integrations" class="text-gray-500 underline hover:text-blue-600" title="Subscribe on the Integrations page to activate">CSV Report</a>
								{/if}
							</div>
							<input type="submit" value="Submit" disabled={searchSubmit}
								class="w-1/2 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
							<div><!-- Spacer --></div>
							<div class='input w-full'>
								<div class="relative">
									<select id="classification-mobile" name="classification" bind:value={classification} class="input-field mt-4 {classificationError === '' ? '' : 'border-red-600'} w-full">
										<option value="">Select a Classification</option><option value="ASBESTOS">ASBESTOS</option><option value="BOILERMAKER">BOILERMAKER</option><option value="BRICKLAYERS">BRICKLAYERS</option><option value="CARPENTERS">CARPENTERS</option><option value="CARPET/LINOLEUM">CARPET/LINOLEUM</option><option value="CEMENT MASONS">CEMENT MASONS</option><option value="DRYWALL FINISHER">DRYWALL FINISHER</option><option value="DRYWALL/LATHERS">DRYWALL/LATHERS</option><option value="ELECTRICIANS">ELECTRICIANS</option><option value="ELEVATOR MECHANIC">ELEVATOR MECHANIC</option><option value="GLAZIERS">GLAZIERS</option><option value="IRON WORKERS">IRON WORKERS</option><option value="LABORERS">LABORERS</option><option value="MILLWRIGHTS">MILLWRIGHTS</option><option value="OPERATING ENG">OPERATING ENG</option><option value="PAINTERS">PAINTERS</option><option value="PILE DRIVERS">PILE DRIVERS</option><option value="PIPE TRADES">PIPE TRADES</option><option value="PLASTERERS">PLASTERERS</option><option value="ROOFERS">ROOFERS</option><option value="SHEET METAL">SHEET METAL</option><option value="SOUND/COMM">SOUND/COMM</option><option value="SURVEYORS">SURVEYORS</option><option value="TEAMSTER">TEAMSTER</option><option value="TILE WORKERS">TILE WORKERS</option>
									</select>
									<label for="classification-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Classification</label>
								</div>
								<p class='error-text {classificationError === '' ? 'hidden' : ''}'>{classificationError}</p>
							</div>
							<div class='input w-full'>
								<div class="relative">
									<select id="contract-amount-mobile" name="contract_amount" bind:value={contractAmount} class="input-field mt-4 {contractAmountError === '' ? '' : 'border-red-600'} w-full">
										<option value="">Select a Contract Amount</option><option value="$0.00 - $5,000">$0.00 - $5,000</option><option value="$5,000 - $50,000">$5,000 - $50,000</option><option value="$50,000 - $500,000">$50,000 - $500,000</option><option value="$500,000 - $5,000,000">$500,000 - $5,000,000</option><option value="$5,000,000 - $50,000,000">$5,000,000 - $50,000,000</option><option value="Greater than $50,000,000">Greater than $50,000,000</option>
									</select>
									<label for="contract-amount-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Contract Amount</label>
								</div>
								<p class='error-text {contractAmountError === '' ? 'hidden' : ''}'>{contractAmountError}</p>
							</div>
							<div></div>


							<fieldset class="flex flex-col space-y-3">
								<div class="segmented-control">
									<button type="button" class="{dateMode === 'upcoming_bids' ? 'active' : ''}" disabled
										title="Note: Bid dates are self-reported after award. This filter may return incomplete results as most records don't have forward-looking bid dates.">
										Upcoming Bids
									</button>
									<button type="button" class="{dateMode === 'awarded' ? 'active' : ''}" on:click={() => dateMode = 'awarded'}
										title="Approximately half of award dates appear to be placeholder values mirroring start date rather than actual award dates.">
										Awarded (pre-NTP)
									</button>
									<button type="button" class="{dateMode === 'active' ? 'active' : ''}" on:click={() => dateMode = 'active'}>
										Active Projects
									</button>
									<button type="button" class="{dateMode === 'all_time' ? 'active' : ''}" on:click={() => dateMode = 'all_time'}>
										All Time
									</button>
								</div>
								<div class="flex space-x-2">
									<div class='input w-1/2'>
										<DateTypeInput id="search-start-date-mobile" name="search_start_date" label="Start" value={searchStartDate}
											disabled={dateMode === 'active' || dateMode === 'awarded'}
											error={searchStartDateError}
											on:input={() => userEditedDates = true}
											on:change={(e) => { searchStartDateError = ''; clampField(e.detail, 'pwc-start-mobile'); }}
											on:invalid={() => searchStartDateError = 'Enter date as MM/DD/YYYY'}/>
									</div>
									<p class="my-auto">-</p>
									<div class='input w-1/2'>
										<DateTypeInput id="search-end-date-mobile" name="search_end_date" label="End" value={searchEndDate}
											disabled={dateMode === 'active' || dateMode === 'awarded'}
											error={searchEndDateError}
											on:input={() => userEditedDates = true}
											on:change={(e) => { searchEndDateError = ''; clampField(e.detail, 'pwc-end-mobile'); }}
											on:invalid={() => searchEndDateError = 'Enter date as MM/DD/YYYY'}/>
									</div>
								</div>
							</fieldset>

							
							<input type="hidden" name="advertised_bid_start_date" value={dateFields.advertised_bid_start_date}/>
							<input type="hidden" name="advertised_bid_end_date" value={dateFields.advertised_bid_end_date}/>
							<input type="hidden" name="project_award_start_date" value={dateFields.project_award_start_date}/>
							<input type="hidden" name="project_award_end_date" value={dateFields.project_award_end_date}/>
							<input type="hidden" name="estimated_start_start_date" value={dateFields.estimated_start_start_date}/>
							<input type="hidden" name="estimated_start_end_date" value={dateFields.estimated_start_end_date}/>
							<input type="hidden" name="estimated_completion_start_date" value={dateFields.estimated_completion_start_date}/>
							<input type="hidden" name="estimated_completion_end_date" value={dateFields.estimated_completion_end_date}/>


							<div class='input w-full'>
								<div class="relative">
									<select id="county-mobile" name="county" bind:value={county} class="input-field mt-4 {countyError === '' ? '' : 'border-red-600'} w-full">
										<option value="">Select a County</option><option value="Out of state:">Out of state:</option><option value="Alameda">Alameda</option><option value="Alpine">Alpine</option><option value="Amador">Amador</option><option value="Butte">Butte</option><option value="Calaveras">Calaveras</option><option value="Colusa">Colusa</option><option value="Contra Costa">Contra Costa</option><option value="Del Norte">Del Norte</option><option value="El Dorado">El Dorado</option><option value="Fresno">Fresno</option><option value="Glenn">Glenn</option><option value="Humboldt">Humboldt</option><option value="Imperial">Imperial</option><option value="Inyo">Inyo</option><option value="Kern">Kern</option><option value="Kings">Kings</option><option value="Lake">Lake</option><option value="Lassen">Lassen</option><option value="Los Angeles">Los Angeles</option><option value="Madera">Madera</option><option value="Marin">Marin</option><option value="Mariposa">Mariposa</option><option value="Mendocino">Mendocino</option><option value="Merced">Merced</option><option value="Modoc">Modoc</option><option value="Mono">Mono</option><option value="Monterey">Monterey</option><option value="Napa">Napa</option><option value="Nevada">Nevada</option><option value="Orange">Orange</option><option value="Placer">Placer</option><option value="Plumas">Plumas</option><option value="Riverside">Riverside</option><option value="Sacramento">Sacramento</option><option value="San Benito">San Benito</option><option value="San Bernardino">San Bernardino</option><option value="San Diego">San Diego</option><option value="San Francisco">San Francisco</option><option value="San Joaquin">San Joaquin</option><option value="San Luis Obispo">San Luis Obispo</option><option value="San Mateo">San Mateo</option><option value="Santa Barbara">Santa Barbara</option><option value="Santa Clara">Santa Clara</option><option value="Santa Cruz">Santa Cruz</option><option value="Shasta">Shasta</option><option value="Sierra">Sierra</option><option value="Siskiyou">Siskiyou</option><option value="Solano">Solano</option><option value="Sonoma">Sonoma</option><option value="Stanislaus">Stanislaus</option><option value="Sutter">Sutter</option><option value="Tehama">Tehama</option><option value="Trinity">Trinity</option><option value="Tulare">Tulare</option><option value="Tuolumne">Tuolumne</option><option value="Ventura">Ventura</option><option value="Yolo">Yolo</option><option value="Yuba">Yuba</option>
									</select>
									<label for="county-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">County</label>
								</div>
								<p class='error-text {countyError === '' ? 'hidden' : ''}'>{countyError}</p>
							</div>

							<!-- <input type="hidden" name="physical_locator_type" value={physicalLocatorType ? 'Location' : 'Address'}/> -->
							<input type="hidden" name="physical_locator_type" value="Address"/>

							<div class='input w-full'>
								<div class="relative">
									<input id="address-line-one-mobile" name="address_line_one" bind:value={addressLineOne} placeholder="Address Line One" class="peer z-20 placeholder:text-transparent {addressLineOneError === '' ? '' : 'border-red-600'}"/>
									<label for="address-line-one-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Address</label>
								</div>
								<p class='error-text {addressLineOneError === '' ? 'hidden' : ''}'>{addressLineOneError}</p>
							</div>

							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="city-mobile" name="city" bind:value={city} placeholder="City" class="peer z-20 placeholder:text-transparent {cityError === '' ? '' : 'border-red-600'}"/>
										<label for="city-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">City</label>
									</div>
									<p class='error-text {cityError === '' ? 'hidden' : ''}'>{cityError}</p>
								</div>
								<div class='input w-1/2'>
									<div class="relative">
										<select id="us-state-mobile" name="us_state" bind:value={usState} class="input-field mt-4 {usStateError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a State</option><option value="AL">AL</option><option value="AK">AK</option><option value="AZ">AZ</option><option value="AR">AR</option><option value="CA">CA</option><option value="CO">CO</option><option value="CT">CT</option><option value="DE">DE</option><option value="DC">DC</option><option value="FL">FL</option><option value="GA">GA</option><option value="HI">HI</option><option value="ID">ID</option><option value="IL">IL</option><option value="IN">IN</option><option value="IA">IA</option><option value="KS">KS</option><option value="KY">KY</option><option value="LA">LA</option><option value="ME">ME</option><option value="MD">MD</option><option value="MA">MA</option><option value="MI">MI</option><option value="MN">MN</option><option value="MS">MS</option><option value="MO">MO</option><option value="MT">MT</option><option value="NE">NE</option><option value="NV">NV</option><option value="NH">NH</option><option value="NJ">NJ</option><option value="NM">NM</option><option value="NY">NY</option><option value="NC">NC</option><option value="ND">ND</option><option value="OH">OH</option><option value="OK">OK</option><option value="OR">OR</option><option value="PA">PA</option><option value="RI">RI</option><option value="SC">SC</option><option value="SD">SD</option><option value="TN">TN</option><option value="TX">TX</option><option value="UT">UT</option><option value="VT">VT</option><option value="VA">VA</option><option value="WA">WA</option><option value="WV">WV</option><option value="WI">WI</option><option value="WY">WY</option>
										</select>
										<label for="us-state-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">State</label>
									</div>
									<p class='error-text {usStateError === '' ? 'hidden' : ''}'>{usStateError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="zipcode-mobile" type="number" min="0" step="1" name="zipcode" bind:value={zipcode} placeholder="Zipcode" class="peer z-20 placeholder:text-transparent {zipcodeError === '' ? '' : 'border-red-600'}"/>
										<label for="zipcode-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Zipcode</label>
									</div>
									<p class='error-text {zipcodeError === '' ? 'hidden' : ''}'>{zipcodeError}</p>
								</div>

							</div>
							<!--{/if}-->
							
							<!-- Sort by removed — appears broken, can restore if needed
							<div class='input w-full'>
								<div class="relative">
									<select id="sort-by-mobile" name="sort_by" bind:value={sortBy} class="input-field mt-4 {sortByError === '' ? '' : 'border-red-600'} w-full">
										<option value="">Select a Sort Filter</option><option value="Awarding Body">Awarding Body</option><option value="Project Name">Project Name</option><option value="Contractor Name">Contractor Name</option><option value="County">County</option><option value="Classification">Classification</option><option value="Contract Amount">Contract Amount</option>
									</select>
									<label for="sort-by-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-2 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Sort Filter</label>
								</div>
								<p class='error-text {sortByError === '' ? 'hidden' : ''}'>{sortByError}</p>
							</div>
							-->

							<input type="hidden" name="which_db" value="New"/>
							<p class="text-sm text-gray-500 mt-2">Data current up to: {dataCurrentDate}</p>
							
						</div>
					</form>
				</div>

				<!-- PWC100 Preview Results -->
				{#if searchState === 'searching'}
					<div class="text-center py-12">
						<!--<p class="text-xl text-blue-600">Searching PWC100 Database...</p>-->
						<p class="text-gray-500 mt-2">This may take a moment</p>
					</div>
				{/if}

				{#if searchState === "preview-data" && previewData}
					<div class="preview-results bg-white p-6 rounded-lg shadow-lg max-w-7xl mx-auto">
						<h2 class="text-3xl font-bold text-blue-900 mb-6">Search Results Preview</h2>

						<p class="text-xl font-semibold text-blue-900 mb-4">
							Total Projects Found:
							<span class="text-blue-600">
								{previewData.total_count?.toLocaleString() ?? 0}
							</span>
						</p>

						{#if previewData.total_count > 100}
							<p class="text-orange-600 mb-4">
								Showing first 100 results in preview. Download full results for complete data.
							</p>
						{/if}

						{#if previewLoading}
							<p class="text-center text-blue-600 mt-6">Loading preview…</p>
						{:else if previewError}
							<p class="text-center text-red-600 mt-6">{previewError}</p>
						{:else}
							<div class="grid md:grid-cols-4 gap-4 mb-6">
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Total Value</p>
									<p class="text-2xl font-semibold text-gray-900">
										${previewMetrics.totalAmount.toLocaleString('en-US', { maximumFractionDigits: 0 })}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Awarding Bodies</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.awardingBodies)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Contractors</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.contractors)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
								<div class="p-4 bg-gray-50 rounded">
									<p class="text-sm text-gray-500">Top Projects</p>
									<p class="text-sm text-gray-700">
										{Object.entries(previewMetrics.projects)
										.sort((a, b) => b[1] - a[1])
										.slice(0, 3)
										.map(([name, count]) => `${name} (${count})`)
										.join(", ") || "N/A"}
									</p>
								</div>
							</div>
 
							
							<div class="space-y-3 max-h-[70vh] overflow-y-auto">
								{#each mobileSortedRows as row}
									<div class="border rounded-lg p-4 bg-white shadow-sm cursor-pointer"
										on:click={() => { if (expandedArr.includes(row.id)) { expandedArr = expandedArr.filter(id => id !== row.id); } else { expandedArr = [...expandedArr, row.id]; } }}>
										<p class="font-semibold text-blue-900 text-base">{row.projectName}</p>
										<p class="text-sm text-gray-600">{row.awardingBody} &middot; {row.awardDate}</p>
										<!-- Same source as the desktop "DIR Proj. ID" column (row.id) -->
										<p class="text-sm text-gray-600">DIR Proj. ID: {row.id ?? 'N/A'}</p>
										<p class="text-sm text-gray-700 mt-1">{row.contractors[0]?.name || 'N/A'}</p>
										<div class="flex justify-between mt-2">
											<span class="text-sm text-gray-500">{row.city}</span>
											<span class="text-sm font-medium">{row.amountFormatted}</span>
										</div>
										{#if expandedArr.includes(row.id)}
											<div class="mt-3 pt-3 border-t">
												<p class="text-xs font-semibold mb-1">All Contractors:</p>
												{#each row.contractors as contractor}
													<p class="text-sm text-gray-700">
														{contractor.name}
														{#if contractor.cslb}
															<span class="text-gray-500">#{contractor.cslb}</span>
														{/if}
														{#if contractor.homeCity}
															<span class="text-gray-500">{contractor.homeCity}</span>
														{/if}
													</p>
												{/each}
											</div>
										{/if}
									</div>
								{/each}
							</div>
							
							<div class="mt-6 flex flex-col space-y-3 items-center">
								{#if pwc100ReportFeature}
									<a href="{getGETAPILink('pwc100-search/download', {'search_id': searchId})}" download="{searchId}.csv" target="_self" on:click={flashDownloadFeedback}>
										<button class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
										Download Full Results
										</button>
									</a>
								{:else}
									<button disabled class="px-6 py-2 text-xl rounded-md bg-gray-400 cursor-not-allowed text-gray-200 font-semibold"
										title="PWC100 Report feature required for download">
									Download Full Results
									</button>
								{/if}
								<button type="button" on:click={newSearch} class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
									New Search
								</button>
							</div>
							{#if downloadFeedback}
								<p class="text-green-700 text-lg text-center mt-2">{downloadFeedback}</p>
							{/if}
						{/if}
					</div>
				{/if}


				<div class="{searchState === 'searching' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">{capitalizeFirstLetter(searchStatus)}</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<div class="mt-5 space-y-3">
						<p class="text-xl font-semibold">Search ID: {searchId}</p>
						{#if searchStatus === 'downloading'}
							<p class="text-xl font-semibold">Status: {capitalizeFirstLetter(searchStatus)}</p>
						{:else if searchStatus === 'finished'}
							<div class="mt-6 flex flex-col space-y-3 items-center">
								{#if pwc100ReportFeature}
									<a href="{getGETAPILink('pwc100-search/download', {'search_id': searchId})}" download="{searchId}.csv" target="_self" on:click={flashDownloadFeedback}>
										<button class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
										Download Full Results
										</button>
									</a>
								{:else}
									<button disabled class="px-6 py-2 text-xl rounded-md bg-gray-400 cursor-not-allowed text-gray-200 font-semibold"
										title="PWC100 Report feature required for download">
									Download Full Results
									</button>
								{/if}
								<button type="button" on:click={newSearch} class="px-6 py-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-white font-semibold">
									New Search
								</button>
							</div>
							{#if downloadFeedback}
								<p class="text-green-700 text-lg text-center mt-2">{downloadFeedback}</p>
							{/if}
						{:else if searchStatus === 'error' || (previewData?.total_count ?? 0) === 0}
							<div class="space-x-5 mt-5">
								<button type="button" on:click={newSearch}
									class="w-5/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								New Search</button>
							</div>
						{/if}
					</div>
				</div>
			</div>
		</div>
	</div>
	<Footer/>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}

	.bc-sliver {
		width: 0.5rem;
		min-width: 0.5rem;
		padding: 0;
		border: none;
		background: transparent;
		outline: none;
		box-shadow: none;
		color: #1e3a8a;
		font-weight: 600;
		text-align: center;
	}

	.segmented-control {
		display: flex;
		border: 1px solid #ccc;
		border-radius: 6px;
		overflow: hidden;
		width: 100%;
	}

	.segmented-control button {
		flex: 1;
		background: #fff;
		border: none;
		border-right: 1px solid #ccc;
		padding: 10px 5px;
		font-size: 0.85rem;
		color: #444;
		cursor: pointer;
		transition: background 0.2s, color 0.2s;
		text-align: center;
	}

	.segmented-control button:last-child {
		border-right: none;
	}

	.segmented-control button.active {
		background: #3b82f6;
		color: #ffffff;
		font-weight: 600;
	}

	.segmented-control button:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}

	@media (max-width: 640px) {
		.segmented-control.segmented-row {
			display: flex;
			grid-template-columns: none;
		}
	}

	@media (max-width: 640px) {
		.segmented-control.segmented-row {
			display: flex;
		}
	}

	@media (max-width: 640px) {
		.segmented-control {
			display: grid;
			grid-template-columns: 1fr 1fr;
		}

		.segmented-control button {
			border-right: 1px solid #ccc;
			border-bottom: 1px solid #ccc;
			padding: 12px 8px;
		}

		.segmented-control button:nth-child(2n) {
			border-right: none;
		}

		.segmented-control button:nth-child(3),
		.segmented-control button:nth-child(4) {
			border-bottom: none;
		}
	}
</style>